import React, {useContext} from "react";
import PropTypes from "prop-types";
import Context from "../ProductsProvider";
import styled from "@emotion/styled";

//style rules
import { Typography, Colors, Sizes } from "../../../styles";

const Filters = ({ filters, category, groupIndex, isExpanded }) => {
	const { data: { activeFilters, language },
		actions: { setParams, setActiveFilters },
	} = useContext(Context);

	const isChecked = (title) => {
		if (!activeFilters.length) return false;
		
		if (activeFilters.some(activeFilter => title === activeFilter)) return true;
		return false;
	}

	const handleClick = (category, slug, title) => {
		setParams((currentValue) => {
			const searchParams = new URLSearchParams(currentValue.toString());
			const categoryValues = searchParams.getAll(category);
			const found = slug !== "bdc" ? categoryValues.includes(slug) : searchParams.has("supported");
			
			if (!found) {
				if (slug === "bdc") {
					searchParams.set("supported", "true");
					searchParams.set("pageNumber", 1);
					return searchParams;
				}

				searchParams.append(category, slug);
				searchParams.set("pageNumber", 1);
				return searchParams;
			} else {
				if (slug === "bdc") {
					searchParams.delete("supported", "true");
					searchParams.set("pageNumber", 1);
					return searchParams;
				}

				searchParams.delete(category, slug);
				searchParams.set("pageNumber", 1);
				return searchParams;
			}
		});

		setActiveFilters((currentValue) => {
			const activeFiltersCopy = [...currentValue];
			const foundIndex = activeFiltersCopy.indexOf(title);

			if (foundIndex !== -1) {
				activeFiltersCopy.splice(foundIndex, 1);
				return activeFiltersCopy;
			} else {
				activeFiltersCopy.push(title);
				return activeFiltersCopy;
			}
		});
	}
	
	const renderLabel = (slug, title) => {
		if (slug !== "bdc") return <label htmlFor={slug}>{title}</label>
		
		if (language === "en") return <label htmlFor={slug}><img src={`${mainScript.assetPath}images/svg/logos/bdc.svg`} alt="supported by BDC" /> supported</label>

		if (language === "fr") return <label htmlFor={slug}>soutenu par <img src={`${mainScript.assetPath}images/svg/logos/bdc.svg`} alt="supported by BDC" /></label>
	}

	const renderCommunityIcons = (slug) => {
		if (category !== "community") return null;

		const frTags = {
			"2slgbtqia-fr": "2slgbtqia",
			"autochtone": "indigenous",
			"femmes": "women",
			"noir-e": "black",
			"nouveaux-arrivants": "newcommers",
		}

		const newSlug = () => {
			if (frTags[slug]) return frTags[slug];

			if (slug === "newcomers") return "newcommers";

			return slug;
		}

		return <CommunityIcon alt="" src={`${mainScript.assetPath}images/svg/icons/${newSlug()}.svg`} />
	}

	if (filters.length === 0) return null;

	return (
		isExpanded[groupIndex] &&
		<Options>
			{
				filters.map( (filter) => {
					return (
						<Option key={filter.slug}>
							<RadioButton
								type="checkbox" 
								id={filter.slug} 
								name={filter.slug} 
								value={filter.title} 
								onClick={() => handleClick(category, filter.slug, filter.title)}
								defaultChecked={isChecked(filter.title)}
							/>
							{renderCommunityIcons(filter.slug)}
							{renderLabel(filter.slug, filter.title)}
						</Option>
					)
				})
			}
		</Options>
	)
}

export default Filters;

Filters.propTypes = {
	filters: PropTypes.array,
	category: PropTypes.string,
	groupIndex: PropTypes.number,
	isExpanded: PropTypes.array,
	supportedIndex: PropTypes.number,
}

const Options = styled.ul`
	list-style: none;
	margin: 2rem 0 0;
	padding: unset;
`;

const Option = styled.li`
	display: flex;
	align-items: center;
	column-gap: 1.5rem;
	padding: unset;
	margin: 0 0 1.2rem;

	&:last-of-type {
		margin-bottom: 0;
	}

	img + label {
		margin-left: -0.9rem;
	}
`;

const CommunityIcon = styled.img`
	display: block;
	height: 3rem;
	width: auto;

	+ label {
	font-size: 1.5rem;
	font-weight: ${Typography.fontWeight.medium};
	line-height: 1.9rem;
	text-transform: initial;
	letter-spacing: inherit;

		img {
			width: 3.1rem;
			height: 1.64rem;
		}
	}
`;

const RadioButton = styled.input`
	appearance: none;
	display: block;
	height: 2.2rem;
	width: 2.2rem;
	border: 1px solid ${Colors.fp.pineGreen};
	border-radius: 0.5rem !important;
	cursor: pointer;

	&[checked] {
		position: relative;
		background-color: ${Colors.fp.pineGreen};
		border: 1px solid ${Colors.fp.pineGreen};

		&::after {
			content: "";
			position: absolute;
			height: 2rem;
			width: 2rem;
			background: url(${`${mainScript.assetPath}images/svg/icons/icon-close-white.svg`}) no-repeat center;
			top: 0;
			left: 0;
			transform: rotate(45deg);
		}
	}

	&:not([type=button]):not([type=submit]):not([type=reset]):not([type=checkbox]):not(.gfield-choice-input) {
		&:hover,
		&:focus-visible,
		&:focus {
			@media only screen and (min-width: ${Sizes.screens.large}) {
				outline: 2px inset -webkit-focus-ring-color;
				border: 1px solid ${Colors.fp.pineGreen} !important;
				box-shadow: unset;
			}
		}
	}

	+ label {
		font-size: 1.5rem;
		font-weight: ${Typography.fontWeight.medium};
		line-height: 1.9rem;
		text-transform: initial;
		letter-spacing: inherit;

		img {
			width: 3.1rem;
			height: 1.64rem;
		}
	}
`;